/**
 * mortgage.js — Monthly payment and present value.
 * Pure functions — zero React.
 */
export function mp(P, r, y) {
  const m = r / 12, n = y * 12;
  return m === 0 ? P / n : P * (m * Math.pow(1 + m, n)) / (Math.pow(1 + m, n) - 1);
}

export function pv(fv, r, y) {
  return y <= 0 ? fv : fv / Math.pow(1 + r, y);
}
